module.exports = __webpack_public_path__ + "img/back.164aeca9.svg";